import type { Nullable } from "@core/domain/types/nullable.type.ts";
import type { ObjectLike } from "@core/domain/types/object-like.type.ts";

export enum PlatformStorageKeysEnum {
    AccessToken = "access_token",
    RememberSession = "remember_session",
}

export interface PlatformStorage {
    get(key: PlatformStorageKeysEnum): Nullable<string>;

    getObject<T extends ObjectLike<T> = Record<string, unknown>>(
        key: PlatformStorageKeysEnum,
    ): Nullable<T>;

    set(key: PlatformStorageKeysEnum, value: string): void;

    setObject(
        key: PlatformStorageKeysEnum,
        value: Record<string, unknown>,
    ): void;

    remove(key: PlatformStorageKeysEnum): void;
}
